import React from 'react'
import LabelTitleText from 'components/shared/LabelTitleText'
import CardsSection from 'components/shared/CardsSection'
import SectionHeaderWithTriangleImage from 'components/shared/SectionHeaderWithTriangleImage'
import Layout from 'components/shared/Layout'
import css from './styles.module.scss'

const TextWithCards = ({
  className,
  triangleImage,
  cardsIntro,
  intro,
  cards,
}) => {
  return (
    <SectionHeaderWithTriangleImage
      className={className}
      triangleImage={triangleImage}
    >
      <Layout type="wrapper" className={css.wrapper}>
        <Layout type="smallInnerWrapper" className={css.innerWrapper}>
          {intro && <LabelTitleText {...intro} className={css.intro} />}
          {cards && cards.length > 0 && (
            <CardsSection
              intro={cardsIntro}
              cards={cards}
              className={css.cardsSection}
            />
          )}
        </Layout>
      </Layout>
    </SectionHeaderWithTriangleImage>
  )
}

TextWithCards.defaultProps = {}

export default TextWithCards
